<div class="flex w-full items-center">
  <modus-label class="text-xs grow select-none">{{
    translations.intensityGradient.text
  }}</modus-label>
  <div class="h-12">
    <mat-slider id="3d-settings-intensity-gradient" [min]="0" [max]="1" [step]="0.1" class="mx-1">
      <input modus-input matSliderThumb [formControl]="formGroup.controls.offset" />
    </mat-slider>

    <div class="flex justify-between relative -top-[14px]">
      <div class="ml-2 -mt-[3px] h-4 w-4">
        <sd-color-picker
          [formControl]="formGroup.controls.startColor"
          [dialogOffset]="'-850'"
          [dialogPosition]="'bottom'"
          [dialogArrowPosition]="'top-right'"
          [dialogSize]="'small'"
        ></sd-color-picker>
      </div>

      <div class="mr-2 -mt-[3px] h-4 w-4">
        <sd-color-picker
          [formControl]="formGroup.controls.endColor"
          [dialogOffset]="'-850'"
          [dialogPosition]="'bottom'"
          [dialogArrowPosition]="'top-right'"
          [dialogSize]="'small'"
        ></sd-color-picker>
      </div>
    </div>
  </div>
</div>
